import { Guideline, ConditionTemplate, ConsequenceTemplate } from "@/modules/guidelines/domain/Guideline";
import { GuidelinesListScreenData, GuidelineDetailScreenData } from "../domain/GuidelinesScreenData";

export class VueGuidelinesListScreenData implements GuidelinesListScreenData{
    guidelines: Guideline[];
    guidelines_headers = [
        {
            text: 'ID',
            align: 'start',
            sortable: false,
            value: 'id',
        },
        { text: 'User', value: 'username' },
        { text: 'Company', value: 'company_name' },
        { text: 'Condition', value: 'condition' },
        { text: 'Consequence', value: 'consequence' },
        { text: 'Description', value: 'description' },
    ];
    limit = 10;
    offset = 0;
    selectedItems: Array<Object>;
    loadingItems: boolean;
    totalItems: Number;
    

    constructor(){
        this.guidelines = []
        this.selectedItems = []
        this.loadingItems = false
        this.totalItems = 0
    }
}

export class VueGuidelineDetailScreenData implements GuidelineDetailScreenData {
    guideline: Guideline;
    condition_options :ConditionTemplate[];
    consequence_options: ConsequenceTemplate[];
    loading: boolean;
    execution_stats: any;
    
    constructor(){
        this.guideline = new Guideline(null, null, null, null, null, {'when':'format_data','condition':{}, 'consequence':{}}, null, null, null)
        this.condition_options = []
        this.consequence_options = []
        this.loading = false
        this.execution_stats = {}
    }
}